import { useContext } from "react";

import { UserContext } from "../auth/user-context";
import { isTrialUser } from "../auth/user-utils";

type EnabledCfcSolutions = {
  isCcfEnabled: boolean;
  isPcfEnabled: boolean;
  isFpcEnabled: boolean;
  isTrialCustomer: boolean;
};

export const useGetEnabledCfcSolutions = (): EnabledCfcSolutions => {
  const { hasPermission } = useContext(UserContext);
  const isTrialCustomer = isTrialUser(hasPermission);
  const isCcfEnabled =
    hasPermission("cfc.ccf-basic.access") ||
    hasPermission("cfc.ccf-enterprise.access") ||
    hasPermission("cfc.ccf-assessment.access") ||
    hasPermission("cfc.ccf-employee-commuting-survey.access");
  const isPcfEnabled = hasPermission("cfc.pcf.access");
  const isFpcEnabled = hasPermission("fpc.access");

  return {
    isCcfEnabled,
    isPcfEnabled,
    isFpcEnabled,
    isTrialCustomer,
  };
};
